import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { msalInstance } from '../auth/msalConfig';

/**
 * Component that initializes authentication state
 * This component doesn't render anything, it just sets up auth state
 */
const AuthInitializer = () => {
  const { accounts } = useMsal();

  useEffect(() => {
    const activeAccount = msalInstance.getActiveAccount();

    // On page load, if no active account but accounts exist, set the first one as active
    if (!activeAccount && accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
    
    // Register an event callback to handle login success
    const callbackId = msalInstance.addEventCallback((event) => {
      if (event.eventType === 'msal:loginSuccess') {
        // Set active account after successful login
        if (event.payload && event.payload.account) {
          msalInstance.setActiveAccount(event.payload.account);
        }
      }
    });
    
    // Cleanup the event callback on unmount
    return () => {
      if (callbackId) {
        msalInstance.removeEventCallback(callbackId);
      }
    };
  }, [accounts]);

  // This component doesn't render anything
  return null;
};

export default AuthInitializer;
